import styled, {css} from 'styled-components';

interface ItemProps {
  readonly theme?: string;
  readonly size?: string;
  readonly color?: string;
  readonly fontSize?: string;
}

export const Tag = styled.span<ItemProps>`
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
  display: inline-block;
  font-size: ${props => (props.fontSize ? props.fontSize : '13px')};
  font-weight: 500;
  padding: 2px 10px;
  text-align: center;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  background-color: ${props => props.color === 'Fail velo' && '#F078FF'};
  background-color: ${props => props.color === 'Sore' && '#46B9FF'};
  background-color: ${props => props.color === 'Fatigue' && '#667CFF'};
  background-color: ${props => props.color === 'Pain' && '#f84958e6'};
  background-color: ${props => props.color === 'Medical Referral' && 'rgba(0,155,158,1)'};

  ${props => {
    const color = props.color ? `background-color: ${props.color};` : '';
    const border = props.theme === 'border' ? `border: 1px solid #BAC1C9;` : '';

    return css`
       {
        ${color}
        ${border}
      }
    `;
  }};
  background-color: ${props => props.theme === 'Active' && '#D6F9DA'};
  border-radius: ${props => props.theme && '12px'} !important;
  color: ${props => props.theme === 'Active' && '#38A446'} !important;

  border: ${props => props.theme === 'Inactive' && '1px solid #BAC1C9'};
  color: ${props => props.theme === 'Inactive' && '#BAC1C9'} !important;

  background-color: ${props => props.theme === 'Info' && '#EBEDF2'};
  font-weight: ${props => props.theme === 'Info' && '600'};
  border: ${props => props.theme === 'Info' && '1px solid #EBEDF2'};
  color: ${props => props.theme === 'Info' && '#5D6E81'} !important;

  border: ${props => props.theme === 'Declined' && '1px solid #BAC1C9'};
  color: ${props => props.theme === 'Declined' && '#BAC1C9'} !important;
  text-decoration: ${props => props.theme === 'Declined' && 'line-through'};

  background-color: ${props => props.theme === 'Pending' && '#FFF5C9'};
  color: ${props => props.theme === 'Pending' && '#CEA701'} !important;

  color: ${props => props.theme === 'border' && '#BAC1C9'} !important;

  width: ${props => props.size === 'large' && 'max-content'} !important;
  width: ${props => props.size === 'smaller' && '30px'} !important;
  width: ${props => props.size === 'small' && '50px'} !important;
  width: ${props => props.size === 'normal' && '75px'}!important;

  border-radius: ${props => props.theme === 'square' && '4px'} !important;
`;
